export default __webpack_public_path__ + "static/Segoe UI Bold-21ecd6932d8c6e2ae14e071a3306b449.woff";